import React from "react";
import { Link } from "react-router-dom";

export default function SinglePlaceCard(props) {
  const confirmDeletingPlace = () => {
    const confirmation = window.confirm("Are you sure you want to delete it?");
    if (confirmation === true) {
      props.deleteHandler(props.placeCity);
    } else {
      return;
    }
  };

  return (
    <div className="mb-4 single-place-cover">
      <div className="single-place main-card-cover">
        {/* Image */}
        <div
          className="img-side mb-3"
          style={{ background: `url(${props.placeImg})` }}
        ></div>
        {/* Details */}
        <div className="details-side">
          <h4 className="mb-1 text-capitalize">{props.placeCity}</h4>
          <p className="m-0 text-capitalize">{props.placeCountry}</p>
        </div>

        {/* Update and Delete Button */}
        <div className="update-delete-btns">
          <Link
            to={`/admin/edit-place/${props.placeCity}`}
            className="update-btn btn"
          >
            <i className="fa-solid fa-pen"></i>
          </Link>
          <button className="del-btn btn" onClick={confirmDeletingPlace}>
            <i className="fa-solid fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
